import { ListItemSectionProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: ListItemSectionProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as ListItemSectionProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      title: 'I am a list section',
    } as ListItemSectionProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
